module.exports = __webpack_public_path__ + "static/media/my_location.e497d300.svg";